// extracted by mini-css-extract-plugin
module.exports = {"parentPath":"styles_parentPath__2gMJT","toggleMenu":"styles_toggleMenu__2XgGX","topDivider":"styles_topDivider__ItodY","item":"styles_item__z7Z4E","icon":"styles_icon__2oeoL"};